// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  margin: 20px;
}
.custom-btn {
  width: 130px;
  height: 40px;
  color: #fff;
  border-radius: 5px;
  padding: 10px 25px;
  font-family: "Lato", sans-serif;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),
    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);
  outline: none;
}

.btn-5 {
  width: 130px;
  height: 40px;
  line-height: 42px;
  padding: 0;
  border: none;
  background: rgb(255, 27, 0);
  background: linear-gradient(
    0deg,
    rgba(255, 27, 0, 1) 0%,
    rgba(251, 75, 2, 1) 100%
  );
}
.btn-5:hover {
  color: #f0094a;
  background: transparent;
  box-shadow: none;
}
.btn-5:before,
.btn-5:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 2px;
  width: 0;
  background: #f0094a;
  box-shadow: -1px -1px 5px 0px #fff, 7px 7px 20px 0px #0003,
    4px 4px 5px 0px #0002;
  transition: 400ms ease all;
}
.btn-5:after {
  right: inherit;
  top: inherit;
  left: 0;
  bottom: 0;
}
.btn-5:hover:before,
.btn-5:hover:after {
  width: 100%;
  transition: 800ms ease all;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/users/button3.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB;2EACyE;EACzE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B;;;;GAIC;AACH;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,QAAQ;EACR,mBAAmB;EACnB;yBACuB;EACvB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,YAAY;EACZ,OAAO;EACP,SAAS;AACX;AACA;;EAEE,WAAW;EACX,0BAA0B;AAC5B","sourcesContent":["button {\n  margin: 20px;\n}\n.custom-btn {\n  width: 130px;\n  height: 40px;\n  color: #fff;\n  border-radius: 5px;\n  padding: 10px 25px;\n  font-family: \"Lato\", sans-serif;\n  font-weight: 500;\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  display: inline-block;\n  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),\n    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);\n  outline: none;\n}\n\n.btn-5 {\n  width: 130px;\n  height: 40px;\n  line-height: 42px;\n  padding: 0;\n  border: none;\n  background: rgb(255, 27, 0);\n  background: linear-gradient(\n    0deg,\n    rgba(255, 27, 0, 1) 0%,\n    rgba(251, 75, 2, 1) 100%\n  );\n}\n.btn-5:hover {\n  color: #f0094a;\n  background: transparent;\n  box-shadow: none;\n}\n.btn-5:before,\n.btn-5:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 2px;\n  width: 0;\n  background: #f0094a;\n  box-shadow: -1px -1px 5px 0px #fff, 7px 7px 20px 0px #0003,\n    4px 4px 5px 0px #0002;\n  transition: 400ms ease all;\n}\n.btn-5:after {\n  right: inherit;\n  top: inherit;\n  left: 0;\n  bottom: 0;\n}\n.btn-5:hover:before,\n.btn-5:hover:after {\n  width: 100%;\n  transition: 800ms ease all;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
